import { useState, useEffect } from 'react';
import api from '../services/api';
import FarmSettingsForm from '../components/FarmSettingsForm';
import PageHeader from '../components/ui/PageHeader';

export default function FarmSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await api.get('/auth/farm-settings');
      const { data } = response.data;

      delete data._id;
      delete data.id;
      delete data.__v;
      delete data.userId;
      delete data.createdAt;
      delete data.updatedAt;
      delete data.isActive;
      delete data.version;
      delete data.lastModifiedBy;

      setSettings(data);
      setShowForm(true);
    } catch (err) {
      if (err.response?.status === 404) {
        setSettings(null);
        setShowForm(true);
      } else {
        setError('Failed to fetch farm settings');
        console.error(err);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data) => {
    delete data.activeCostParameters;
    delete data.activeDiscountTiers;
    delete data.activeExtraServices;
    delete data.activeTimelineTiers;
    delete data.farmStats;
    delete data.availableLanguages;

    try {
      await api.patch('/auth/farm-settings', data);
      fetchSettings();
    } catch (err) {
      alert('Failed to save settings: ' + (err.response?.data?.message || err.message));
      throw err;
    }
  };

  const handleReset = async () => {
    if (!window.confirm('Are you sure you want to reset all settings to defaults? This cannot be undone.')) {
      return;
    }
    try {
      await api.post('/auth/farm-settings/reset');
      fetchSettings();
    } catch (err) {
      alert('Failed to reset settings');
      console.error(err);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete your settings? You can create new settings later.')) {
      return;
    }
    try {
      await api.delete('/auth/farm-settings');
      fetchSettings();
    } catch (err) {
      alert('Failed to delete settings');
      console.error(err);
    }
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (error) return <div className="text-center py-8 text-red-600">{error}</div>;

  return (
    <div>
      {showForm && (
        <FarmSettingsForm
          settings={settings}
          onSave={handleSave}
          onReset={handleReset}
          onDelete={settings ? handleDelete : null}
        />
      )}
    </div>
  );
}
